import { app } from '../../app';

app.factory('UserAccountsService', UserAccountsService);

/** @ngInject */
function UserAccountsService($resource) {
    var rootUrl = 'app/rest/admin/company/:companyId/application/:appId/manageapp/useraccounts';

    return {
        assignedGroups : $resource(rootUrl),
        userAccountAction : $resource(rootUrl + '/group/:groupId')
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/application-usage-report/user-accounts.service.js